import React from 'react'
import { Cdn } from 'utils/assets'

type LogoProps = {
  className?: string
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <img
      src={Cdn.getImageUrl('bookfair/arvore-logo-10-anos.avif')}
      alt="Árvore logo"
      className={className}
      role="img"
    />
  )
}
